/* ============
 * Price field Transformer
 * ============
 */

import Transformer from './transformer';

export default class PriceFieldTransformer extends Transformer {

  static fetch(model) {
    return {
      id: model.id,
      field: model.field,
      name: model.name,
      organizationId: model.organization_id,
      exclusiveToPlan: model.exclusive_to_plans,
    };
  }

  static send(model) {
    return {
      id: model.id,
      field: model.field,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/priceField.js